import { IntlShape } from 'react-intl'
import _round from 'lodash/round'
import { DateTime } from 'luxon'
import { Row } from 'react-table'

import { SubscriptionInfo } from 'features/home/types'

import { subscriptionManagementMessages } from './SubscriptionManagement/messages'
import { SubscriptionHistoryConfig, SubscriptionInterval } from './types'

export const formatPrice = (price: number): string => {
  const formattedPrice = _round(Math.abs(price) / 100, 2).toLocaleString(
    'en-US',
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  )
  return price < 0 ? `-$${formattedPrice}` : `$${formattedPrice}`
}

export const formatRecurringPrice = (
  price: number,
  interval: SubscriptionInterval,
  formatMessage: IntlShape['formatMessage']
) => {
  const priceFormatted = formatPrice(price)
  if (interval === 'month') {
    return formatMessage(subscriptionManagementMessages.monthlyPrice, {
      price: priceFormatted,
    })
  }
  return formatMessage(subscriptionManagementMessages.yearlyPrice, {
    price: priceFormatted,
  })
}

export const getInvoiceDiscountCoupon = (invoice: any) => {
  return invoice?.discount?.coupon
}

export const getInvoiceDiscountAmount = (invoice: any) => {
  return invoice?.total_discount_amounts?.[0]?.amount
}

export const getInvoiceHasAutoAppliedCoupon = (invoice: any) => {
  return Boolean(
    getInvoiceDiscountCoupon(invoice) && getInvoiceDiscountAmount(invoice) === 0
  )
}

export const getHistoryPlanAndName = (planHistoryName: string) => {
  const planNameArray = planHistoryName
    .split(/(\s+)/)
    .filter((e) => e.trim().length > 0)
  const status = planNameArray.slice(2).join(' ')
  return { planName: planNameArray.slice(0, 2).join(' '), status }
}

export const isExpiringSoon = (
  subscription: SubscriptionInfo | null | undefined,
  dateNow: DateTime
) => {
  if (subscription) {
    return (
      !subscription.autoRenew &&
      DateTime.fromMillis(subscription.expiresAt).diff(dateNow, 'months')
        .months <= 3
    )
  }
  return false
}

export function sortByPaymentMethod(
  rowA: Row<SubscriptionHistoryConfig>,
  rowB: Row<SubscriptionHistoryConfig>,
  id: string,
  desc?: boolean
) {
  const valueACardBand = rowA?.values[id]?.cardBrand || ''
  const valueALast4 = rowA?.values[id]?.last4 || ''
  const valueA = `${valueACardBand}${valueALast4}`.toLowerCase()

  const valueBCardBand = rowB?.values[id]?.cardBrand || ''
  const valueBLast4 = rowB?.values[id]?.last4 || ''
  const valueB = `${valueBCardBand}${valueBLast4}`.toLowerCase()

  if (desc) {
    return valueA.localeCompare(valueB) > 0 ? 1 : -1
  }

  return valueB.localeCompare(valueA) > 0 ? -1 : 1
}
